<template>
  <div class="absolute left-0 bottom-0 top-0 pa4 flex flex-column justify-between">
    <NavSidebar
      v-if="navigation"
      :brand="development.brand"
      :items="navigation"
      title="About"
    />
    <div />
  </div>
</template>

<script>
import NavSidebar from '@/components/NavSidebar'

export default {
  name: 'Sidebar',
  components: {
    NavSidebar
  },
  computed: {
    development () {
      if (this.$store.state.content) {
        return this.$store.getters.getDevelopment('developments/' + this.$route.params.id)
      } else {
        return null
      }
    },
    navigation () {
      const purchaseOptions = []
      if (this.$store.state.content) {
        this.$store.state.content.purchaseOptions.forEach(element => {
          const item = {
            title: element.title
          }
          purchaseOptions.push(item)
        })
        return [
          {
            title: 'Company',
            route: '/developments/' + this.$route.params.id + '/about/company'
          },
          {
            title: 'Purchase Options',
            route: '/developments/' + this.$route.params.id + '/about/options',
            children: purchaseOptions
          },
          {
            title: 'Buying Process',
            route: '/developments/' + this.$route.params.id + '/about/buying-process'
          },
          {
            title: 'Testimonials',
            route: '/developments/' + this.$route.params.id + '/about/testimonials'
          }
        ]
      } else {
        return null
      }
    }
  }
}
</script>
